import { io } from 'socket.io-client';

export function connectLiveUpdates() {
  return io(process.env.REACT_APP_SOCKET_URL || undefined, {
    // Re-evaluate on reconnect: an earlier session's JWT must not be reused.
    auth: callback => callback({ token: localStorage.getItem('token') }),
  });
}
